@if (careproviderUnit()) {
  @if (!isMobile()) {
    <h1 class="text-3xl font-bold mb-2 hidden md:block">{{ careproviderUnit().name }}</h1>
  }
  <div class="flex flex-col gap-4 small-widgets-container">
    @if (!isMobile()) {
      <app-cpru-small-widgets class="hidden md:flex"></app-cpru-small-widgets>
    }

    <div>
      @if (shortDesctiption()) {
        <div [innerHtml]="shortDesctiption()"
             class="text-base mb-4 line-clamp-4 text-grey-0"></div>
      }

      <div (click)="scrollToAboutSection()"
           class="text-base text-duck-blue-2 flex justify-start items-center gap-1 cursor-pointer underline">
        Läs mer
      </div>
    </div>
  </div>
}

